






































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Claim } from '@/types';
import { partyService } from '@/services/party.services';
import { userService } from '@/services/user.services';
import { User } from '@/stores/authentication/types';

@Component
export default class NewClaimModal extends Vue {
    @Action('getUsers', { namespace: 'dashboard' }) getUsers: any;
    @Getter('users', { namespace: 'dashboard' }) getUsersData!: User[];
    @Getter('user', { namespace: 'authentication' }) userData!: any;
    @Prop({ default: 'New Claim'}) readonly title!: string;
    @Prop({
        default: {
            defender: undefined,
            offender: undefined,
            status: 'IN_PROGRESS',
            assignee: undefined,
        },
    }) readonly claim!: Claim;

    claimData: Claim = Object.assign({}, this.claim);
    titleData: string = this.title;

    parties: any = [];
    assignees: any = [];
    status: string[] = ['IN_PROGRESS', 'ARCHIVED'];

    @Watch('claimData.assignee')
    @Watch('claimData.offender')
    @Watch('claimData.defender')
    updateIds() {
        this.claimData.assignee_id = this.claimData.assignee && this.claimData.assignee.id;
        this.claimData.offender_id = this.claimData.offender && this.claimData.offender.id;
        this.claimData.defender_id = this.claimData.defender && this.claimData.defender.id;
    }

    mounted() {
        partyService.select()
        .then((result) => {
            this.parties = result.data.data;
        });
        userService.select()
        .then((result) => {
            this.assignees = result.data.data;
        });
        this.getUsers();
    }



    showModal() {
        this.$validator.reset();
        this.claimData = Object.assign({}, this.claim);
        if (this.claimData.id) {
            this.titleData = 'Edit Claim';
        } else {
            this.titleData = 'New Claim';
        }
        (this.$refs.modal as any).show();
    }

    saveModal() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                (this.$refs.modal as any).hide();
                this.save();
            }
        });
    }

    @Emit()
    save() {
        return this.claimData;
    }

    validateField(name: string) {
        if (this.veeFields[name] && (this.veeFields[name].dirty || this.veeFields[name].validated)) {
          return !this.errors.has(name);
        }
        return null;
    }

    searchParty(search: string, loading: any) {
        loading(true);
        partyService.select(search)
        .then((result) => {
            this.parties = result.data.data;
            loading(false);
            return result.data.data;
        });
    }

    searchAssignee(search: string, loading: any) {
        loading(true);
        userService.select(search)
        .then((result) => {
            this.assignees = result.data.data;
            loading(false);
        });
    }

    get users() {
        return this.getUsersData && this.getUsersData.map((val) => {
            return {
                value: val,
                text: val.name,
            };
        });
    }
}
